import type { FaireBrandEntity } from "../../entity_types/brand";

export const b_dmbf9ay7t4: FaireBrandEntity = {
  token: "b_dmbf9ay7t4",
  type: "brand",
  name: "My Casita",
  avatarUrl:
    "https://cdn.faire.com/fastly/8562bdf18abb6fee681e8b5f86de2e2bffeabe54b11f2db6e8c5e52e1f54eb5b.jpeg",
  bannerUrl:
    "https://cdn.faire.com/fastly/140a0f35c461cd0135588e6d10e4563d26d55559597339f9a593858424fbd347.jpeg",
  logoUrl:
    "https://cdn.faire.com/fastly/8562bdf18abb6fee681e8b5f86de2e2bffeabe54b11f2db6e8c5e52e1f54eb5b.jpeg",
  heroImageUrl:
    "https://cdn.faire.com/fastly/140a0f35c461cd0135588e6d10e4563d26d55559597339f9a593858424fbd347.jpeg",
  location: "The Woodlands, TX, USA",
  minimumOrderDollars: 150,
  rating: 4.8,
  reviewCount: 51,
  isTopShop: true,
  isInsider: true,
  description:
    "My Casita means “my little home,” and that spirit lives at the heart of everything we create.\nWe design kitchen, home, and gift pieces that bring vibrant color, personality, and conversation into everyday life. What began as a love for bold color and playful pattern has grown into a joyful, expressive collection made to stand out in any setting.\n\nToday, My Casita features more than 700 SKUs spanning bowls, trays, pedestals, and more. Each piece is crafted from sustainable mango wood by third-generation family artisans, blending timeless craftsmanship with a bright, cheerful style. The result is a collection full of charm, made to delight customers and spark stories wherever it’s shared.",
  meta: {
    source: "api",
    importedAt: "2026-08-15T03:51:33.013Z",
    importedBy: "entity-db-cli",
  },
};
